<template>
  <div v-if="getPermission.loads.view">

    <md-tabs md-sync-route class="load-and-bill-tabs">
      <md-tab id="tab-load" md-label="Load" to="/loadAndBillOfLoad/loads"></md-tab>
      <md-tab id="tab-bill-of-loads" md-label="BOL" to="/loadAndBillOfLoad/billOfLoads"></md-tab>
      <md-tab id="tab-bill-of-loads-problems" md-label="BOL Problem & Photo" to="/loadAndBillOfLoad/billOfLoadProblems"></md-tab>
    </md-tabs>
    <router-view/>

  </div>
</template>

<style lang="scss">
  .load-and-bill-tabs {
    .md-tabs-navigation {
      .md-theme-default {
        height: 30px;
      }
    }
  }
</style>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({}),
    computed: {
      ...mapGetters([
        'getPermission',
        'getMasterDataName',
      ]),
    },
  };

</script>
